import { Component, OnInit } from '@angular/core';
import { MyTeamsService } from '../../services/my-teams.service';
import { AppState, AppFields, AppTypes, Store, DocumentUtil } from '../../store';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.css']
})
export class ComingSoonComponent implements OnInit {

  public teamID;

  constructor(
    public service: MyTeamsService,
    private store: Store<AppState>
  ) {
    this.store.select(AppFields.App, AppFields.MyTeam).subscribe(team => {
      if (team != null) {
        this.teamID = team.teamID;
      }
    });
    this.service.links = [{ title: 'Schedules - System Games', url: '/team-admin/team/system-games/' + this.teamID }, { title: 'Coming Soon', url: '' }];
  }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/components/coming-soon/coming-soon.component.ts